import {API_URL, apiDelete} from '../api'

// DELETE /v3/admin/feed_template/:id — 템플릿 영구 삭제.
export const deleteFeedTemplate = async (id: string) => {
    return await apiDelete(API_URL, `admin/feed_template/${id}`, {})
}
